export default {
  GET_DEPOSIT_GUID_REQUEST: 'TERMS_DEPOSIT/GET_DEPOSIT_GUID_REQUEST',
  GET_DEPOSIT_GUID_SUCCESS: 'TERMS_DEPOSIT/GET_DEPOSIT_GUID_SUCCESS',
  GET_DEPOSIT_GUID_FAILURE: 'TERMS_DEPOSIT/GET_DEPOSIT_GUID_FAILURE',
  VERIFY_EMAIL_REQUEST: 'TERMS_DEPOSIT/VERIFY_EMAIL_REQUEST',
  VERIFY_EMAIL_SUCCESS: 'TERMS_DEPOSIT/VERIFY_EMAIL_SUCCESS',
  VERIFY_EMAIL_FAILURE: 'TERMS_DEPOSIT/VERIFY_EMAIL_FAILURE',
  ACCEPT_TYC_REQUEST: 'TERMS_DEPOSIT/ACCEPT_TYC_REQUEST',
  ACCEPT_TYC_SUCCESS: 'TERMS_DEPOSIT/ACCEPT_TYC_SUCCESS',
  ACCEPT_TYC_FAILURE: 'TERMS_DEPOSIT/ACCEPT_TYC_FAILURE',
}



// WEBPACK FOOTER //
// ./src/sections/termsDeposit/types/terms.js